import trackEvent from './track-event';
import sendToServer from './send-to-server';

const Careers = {
  init() {
    if (!($('.careers').length > 0)) return;
    if ($('.recommendation').length > 0) trackEvent('Careers', 'recommendation offered');
    $('.quick-start').click(this.handleQuickStartClick.bind(this));
    $('.recommendation').click(this.handleRecommendationClick.bind(this));
    $('.id-holder .remover').click(this.handleFavouriteRemoverClick.bind(this));
    $('.add-favourite-button').click(this.handleAddFavouriteClick.bind(this));
    $('.recommendation .remover').click(this.handleRecommendationRemoverClick.bind(this));
  },

  handleQuickStartClick(event) {
    trackEvent('Careers', 'used quick-start button');
  },

  handleRecommendationClick() {
    sendToServer('/api/v2/events',
                 { event: 'tried_recommendation',
                   career_id: $('.recommendation-button').data('career-id') });
    trackEvent('Careers', 'recommendation accepted');
  },

  handleFavouriteRemoverClick(event) {
    const career = $(event.target).closest('.id-holder');
    sendToServer('/api/v2/career_relationships/' + career.data('career-id'),
                 { favourite: false },
                 () => { location.reload() },
                 "PATCH");
  },

  handleAddFavouriteClick() {
    const careerId = $('#new-favourite').val();
    sendToServer('/api/v2/career_relationships/' + careerId,
                 { favourite: true },
                 () => { location.reload() },
                 "PATCH");
  },

  handleRecommendationRemoverClick(event) {
    const remover = $(event.target).closest('.remover');
    sendToServer('/api/v2/career_relationships/' + remover.data('career-id'),
                 { hidden: true },
                 () => { location.reload() },
                 "PATCH");
  }
};

$(document).ready(()=> {
  Careers.init();
});
